import React, {useState, useRef} from "react";

export default function AppInputWithAddLabel(props) {
    const {
        stFormClass,
        inputType,
        labelName,
        isRequired,
        placeholder,
        fieldName,
        fieldId,
        noErrorMessage,

        addLabel,

        value,
        onChange = () => { },
        onFocus = () => { },
        onBlur = () => { },
        error,
        isDisabled
    } = props;

    // states
    const [inputFocus, setInputFocus] = useState(false)

    // refs
    const inputRef = useRef(null)

    // on focus
    const onInputFocus = ev => {
        setInputFocus(true)
    }

    // on blur
    const onInputBlur = ev => {
        setInputFocus(false)
    }

    return (
        <div className={`st-form-with-add-label ${stFormClass || ""} ${error ? "has-msg msg-error" : "" } ${isDisabled ? "disabled-elem" : ""}`}>
            {labelName ? (
                <label>
                    {labelName}
                    {isRequired && (
                        <span className="required ms-1 st-fs-12">
                            (required)
                        </span>
                    )}
                </label>
            ) : null}

            {/* main field */}
            <div className={`content-main d-flex ${inputFocus ? "focus" : ""}`} onClick={() => inputRef?.current?.focus()}>
                {
                    // additional label
                    addLabel ? (
                        <div className="add-label">
                            {addLabel}
                        </div>
                    ) : null
                }

                {/* input */}
                <input
                    type={inputType ?? "text"}
                    className="media-body"
                    placeholder={placeholder}
                    name={fieldName}
                    id={fieldId}
                    disabled={isDisabled}
                    ref={inputRef}
                    value={value}
                    onChange={onChange}
                    onFocus={ev => {
                        onInputFocus(ev) // custom focus function

                        onFocus() // custom focus function if any
                    }}
                    onBlur={ev => {
                        onInputBlur(ev) // custom focus function

                        onBlur() // custom blur function if any
                    }}
                />
            </div>
            
            {
                /* form message */
                !noErrorMessage ? (error) && (
                          <div className="st-form-msg">
                              <p className="st-fs-12">
                                  {error}
                              </p>
                          </div>
                      )
                    : null
            }
        </div>
    );
}
